import React, { useState } from "react";
import TopToolbar from "../components/TopToolbar"; // 導入 TopToolbar

function AdminPage() {
    const overlayStyles = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // 半透明背景
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000, // 確保遮罩層在最上方
    };

    const spinnerStyles = {
        width: "50px",
        height: "50px",
        border: "6px solid #f3f3f3", // 外環顏色
        borderTop: "6px solid #3498db", // 頂部顏色
        borderRadius: "50%",
        animation: "spin 1s linear infinite", // 旋轉動畫
    };

    const [serialInput, setSerialInput] = useState("");
    const [serialCode, setSerialCode] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [scheduleData, setScheduleData] = useState([]);
    const [error, setError] = useState("");
    const [showAddSchedule, setShowAddSchedule] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // 添加對照表
    // 添加對照表
    const deviceMacMap = {
        "HKAP0100000114": "76C130102E8A",
        "HKAP0100000031": "",
        "HKAP0100000032": "",
        "HKAP0100000033": "",
        "HKAP0100000034": "",
        "HKAP0100000035": "76C130402B39",
        "HKAP0100000036": "",
        "HKAP0100000037": "78C130402B3A",
        "HKAP0100000038": "76C130202C74",
        "HKAP0100000039": "",
        "HKAP0100000040": "",
        "HKAP0100000041": "",
        "HKAP0100000042": "",
        "HKAP0100000043": "",
        "HKAP0100000044": "76C130402B3B",
        "HKAP0100000045": "76C130302BD1",
        "HKAP0100000046": "76C130402B33",
        "HKAP0100000047": "76C130502BB9",
        "HKAP0100000048": "",
        "HKAP0100000049": "",
        "HKAP0100000050": "76C130102E9D",
        "HKAP0100000051": "",
        "HKAP0100000052": "76C130102E9E",
        "HKAP0100000053": "",
        "HKAP0100000054": "76C130202C7C",
        "HKAP0100000055": "",
        "HKAP0100000056": "76C130302BE5",
        "HKAP0100000057": "76C130202C6C",
        "HKAP0100000058": "76C130402B26",
        "HKAP0100000059": "76C130202C7B",
        "HKAP0100000060": "76C130402B2C",
        "HKAP0100000061": "76C130302BDE",
        "HKAP0100000062": "76C130102EA0",
        "HKAP0100000063": "76C130302BDF",
        "HKAP0100000064": "",
        "HKAP0100000065": "",
        "HKAP0100000066": "",
        "HKAP0100000067": "76C130502BAB",
        "HKAP0100000068": "76C130402B32",
        "HKAP0100000069": "",
        "HKAP0100000070": "",
        "HKAP0100000071": "76C130102E97",
        "HKAP0100000072": "",
        "HKAP0100000073": "",
        "HKAP0100000074": "76C130102E92",
        "HKAP0100000075": "",
        "HKAP0100000076": "",
        "HKAP0100000077": "",
        "HKAP0100000078": "76C130502BB7",
        "HKAP0100000079": "76C130602421",
        "HKAP0100000080": "",
        "HKAP0100000081": "",
        "HKAP0100000082": "",
        "HKAP0100000083": "",
        "HKAP0100000084": "",
        "HKAP0100000085": "",
        "HKAP0100000086": "",
        "HKAP0100000087": "",
        "HKAP0100000088": "",
        "HKAP0100000089": "",
        "HKAP0100000090": "",
        "HKAP0100000091": "",
        "HKAP0100000092": "",
        "HKAP0100000093": "",
        "HKAP0100000094": "",
        "HKAP0100000095": "",
        "HKAP0100000096": "",
        "HKAP0100000097": "",
        "HKAP0100000098": "",
        "HKAP0100000099": "",
        "HKAP0100000100": "76C130102E8E",
        "HKAP0100000101": "76C130402B34",
        "HKAP0100000102": "76C130302BE6",
        "HKAP0100000103": "",
        "HKAP0100000104": "76C130402B38",
        "HKAP0100000105": "76C130602424",
        "HKAP0100000106": "76C130202C72",
        "HKAP0100000107": "76C130202C76",
        "HKAP0100000108": "76C130502BAA",
        "HKAP0100000109": "76C130202C6F",
        "HKAP0100000100": "76C130102E9A",
        "HKAP0100000111": "76C130402B35",
        "HKAP0100000112": "76C130202C6A",
        "HKAP0100000113": "76C130402B27",
        "HKAP0100000114": "",
        "HKAP0100000115": "76C130302BDD",
        "HKAP0100000116": "76C130602414",
        "HKAP0100000117": "76C130502BBB",
        "HKAP0100000118": "76C130502BBC",
        "HKAP0100000119": "76C13060241E",
        "HKAP0100000120": "76C130102E8F",
        "HKAP0100000121": "76C130502BBE",
        "HKAP0100000122": "76C130602411",
        "HKAP0100000123": "76C130402B2E",
        "HKAP0100000124": "76C130402B36",
        "HKAP0100000125": "",
        "HKAP0100000126": "76C130202C78",
        "HKAP0100000127": "76C130302BE1",
        "HKAP0100000128": "76C130102E9C",
        "HKAP0100000129": "76C130502BAD",
        "HKAP0100000130": "76C13060241D",
        "HKAP0100000131": "",
        "HKAP0100000132": "76C130602412",
        "HKAP0100000133": "76C130102E8B",
        "HKAP0100000134": "",
        "HKAP0100000135": "76C130602422",
        "HKAP0100000136": "76C130302BDA",
        "HKAP0100000137": "76C130102E8C",
        "HKAP0100000138": "76C130302BDB",
        "HKAP0100000139": "76C130202C77",
        "HKAP0100000140": "76C130302BE7",
        "HKAP0100000141": "76C130302BDC",
        "HKAP0100000142": "76C130102E97",
        "HKAP0100000143": "76C130202C6B",
        "HKAP0100000144": "76C130302BE2",
        "HKAP0100000145": "76C130602415",
        "HKAP0100000146": "76C130402B37",
        "HKAP0100000147": "76C130502BAC",
        "HKAP0100000148": "76C130102E96",
        "HKAP0100000149": "76C130202C7F",
        "HKAP0100000150": "",
        "HKAP0100000151": "",
        "HKAP0100000152": "",
        "HKAP0100000153": "",
        "HKAP0100000154": "",
        "HKAP0100000155": "76C13040241B",
        "HKAP0100000156": "76C130602426",
        "HKAP0100000157": "",
        "HKAP0100000158": "",
        "HKAP0100000159": "",
        "HKAP0100000160": ""
    };

    // 查找 MAC 地址
    const macAddress = deviceMacMap[serialCode] || "MAC address not found";

    // 新增 schedule form 的欄目狀態
    const [newSchedule, setNewSchedule] = useState({
        timezone: "8",
        dateStart: "",
        timeStart: "",
        dateEnd: "",
        timeEnd: "",
        aromaScent: "Metal",
        aromaIntensity: "",
    });

    // 處理序列號輸入
    const handleSerialSubmit = async () => {
        if (serialInput.length === 3 && /^[0-9]{3}$/.test(serialInput)) {
            setIsLoading(true);
            setError("");

            // 模擬生成完整序列碼
            const generatedSerialCode = `HKAP0100000${serialInput}`;
            setSerialCode(generatedSerialCode);

            // 發送 API 請求
            try {
                const response = await fetch(
                    "https://7dqq5knnv0.execute-api.ap-southeast-1.amazonaws.com/get-schedules",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ serial_number: generatedSerialCode }),
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP Error: ${response.status}`);
                }

                const data = await response.json();

                // 按開始時間 (start_time) 排序數據
                const sortedData = data.sort(
                    (a, b) => new Date(a.start_time) - new Date(b.start_time)
                );

                setScheduleData(sortedData);
            } catch (err) {
                console.error("API Error:", err);
                setError("API Error: No Schedule Data Retrieved!");
            } finally {
                setIsLoading(false);
            }
        } else {
            alert("Please enter last 3 digits of serial number!");
        }
    };

    // 處理新增 schedule form 的欄位變化
    const handleScheduleInputChange = (e) => {
        const { name, value } = e.target;

        let processedValue = value;

        if (name === "aromaIntensity") {
            const numericValue = parseInt(value, 10);

            // 如果輸入的值小於 1 或大於 100，則矯正為邊界值
            if (numericValue < 1) {
                processedValue = 1;
            } else if (numericValue > 100) {
                processedValue = 100;
            } else {
                processedValue = numericValue;
            }
        }

        setNewSchedule({ ...newSchedule, [name]: processedValue });
    };

    const handleAddScheduleSubmit = async () => {

        console.log("Current Form Data:", newSchedule);

        if (!newSchedule.aromaScent) {
            setNewSchedule((prev) => ({ ...prev, aromaScent: "Metal" }));
        }

        if (
            !newSchedule.dateStart ||
            !newSchedule.dateEnd ||
            !newSchedule.timeStart ||
            !newSchedule.timeEnd ||
            !newSchedule.aromaScent ||
            (newSchedule.aromaScent !== "OFF" && (!newSchedule.aromaIntensity || newSchedule.aromaIntensity < 1 || newSchedule.aromaIntensity > 100))
        ) {
            alert("Please fill in all fields with valid values!");
            return;
        }

        // 設置 isSubmitting 為 true，顯示等待動畫
        setIsSubmitting(true);

        try {
            const timezoneOffset = new Date().getTimezoneOffset();
            const offsetHours = String(Math.abs(Math.floor(timezoneOffset / 60))).padStart(2, "0");
            const offsetMinutes = String(Math.abs(timezoneOffset % 60)).padStart(2, "0");
            const timezone = timezoneOffset <= 0
                ? `+${offsetHours}:${offsetMinutes}`
                : `-${offsetHours}:${offsetMinutes}`;

            const start_time = `${newSchedule.dateStart}T${newSchedule.timeStart}:00${timezone}`;
            const end_time = `${newSchedule.dateEnd}T${newSchedule.timeEnd}:00${timezone}`;

            const response = await fetch(
                "https://7dqq5knnv0.execute-api.ap-southeast-1.amazonaws.com/add-schedule",
                {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        serial_number: serialCode,
                        timezone: newSchedule.timezone,
                        start_time,
                        end_time,
                        aroma_scent: newSchedule.aromaScent,
                        aroma_intensity: parseInt(newSchedule.aromaIntensity),
                    }),
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP Error: ${response.status}`);
            }

            alert("New schedule added successfully!");
            setNewSchedule({
                timezone: "8",
                dateStart: "",
                timeStart: "",
                dateEnd: "",
                timeEnd: "",
                aromaScent: "Metal",
                aromaIntensity: "",
            });
        } catch (err) {
            console.error("API Error:", err);
            alert("Failed to add schedule!");
        } finally {
            // 提交完成後，隱藏等待動畫
            setIsSubmitting(false);
        }
    };

    return (
        
        <div style={{ fontFamily: "Arial, sans-serif", textAlign: "center", padding: "20px" }}>
            {isSubmitting && (
                <div style={overlayStyles}>
                    <div style={spinnerStyles}></div>
                </div>
            )}

<TopToolbar /> {/* 使用 TopToolbar */}
            <h1>MASTER ADMIN</h1>
            <div style={{ marginBottom: "20px" }}>
                <input
                    type="text"
                    placeholder="Last 3 digits of AromaPodPro SN"
                    value={serialInput}
                    onChange={(e) => setSerialInput(e.target.value)}
                    maxLength={3}
                    style={{
                        padding: "10px",
                        fontSize: "16px",
                        textAlign: "center",
                        width: "250px",
                    }}
                />
                <button
                    onClick={handleSerialSubmit}
                    style={{
                        padding: "10px 20px",
                        marginLeft: "10px",
                        fontSize: "16px",
                        cursor: "pointer",
                    }}
                >
                    Enter
                </button>
            </div>
            {isLoading ? (
                <div
                    style={{
                        display: "inline-block",
                        border: "4px solid #f3f3f3",
                        borderRadius: "50%",
                        borderTop: "4px solid #3498db",
                        width: "30px",
                        height: "30px",
                        animation: "spin 1s linear infinite",
                        margin: "20px auto",
                    }}
                ></div>
            ) : serialCode ? (
                <div>
                    <h2>AromaPodPro: {serialCode}</h2>
                    {serialCode && (
                        <div style={{ marginTop: "10px", fontSize: "16px", color: "#555" }}>
                            <strong>Sleeping-device MAC Address: </strong>
                            {macAddress}
                        </div>
                    )}
                    {scheduleData.length > 0 ? (
                        <div>
                            {/* 新增 Header 和 Schedule 總計 */}
                            <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
                                Current Schedules ({scheduleData.length})
                            </h3>
                            <ul
                                style={{
                                    padding: 0,
                                    listStyle: "none",
                                    textAlign: "left",
                                    margin: "20px auto",
                                    maxWidth: "500px",
                                }}
                            >
                                {scheduleData.map((schedule, index) => (
                                    <li
                                        key={index}
                                        style={{
                                            backgroundColor: "#f9f9f9",
                                            marginBottom: "10px",
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            borderRadius: "5px",
                                        }}
                                    >
                                        <strong>Start Time: </strong>{" "}
                                        {new Date(schedule.start_time).toLocaleString()} <br />
                                        <strong>End Time: </strong>{" "}
                                        {new Date(schedule.end_time).toLocaleString()} <br />
                                        <strong>Schedule: </strong>{" "}
                                        {`${schedule.scheduled_paramters.element}, ${schedule.scheduled_paramters.intensity}/100 (Level: ${(schedule.scheduled_paramters.intensity / 100) * 5
                                            })`}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : error ? (
                        <div className="error" style={{ color: "red" }}>
                            {error}
                        </div>
                    ) : (
                        <p>No schedule data retrieved.</p>
                    )}
                    <button
                        onClick={() => setShowAddSchedule(!showAddSchedule)}
                        style={{
                            padding: "10px 20px",
                            marginTop: "20px",
                            fontSize: "16px",
                            cursor: "pointer",
                        }}
                    >
                        {showAddSchedule ? "Close Add Schedule" : "Add New Schedule"}
                    </button>
                    {showAddSchedule && (
                        <div style={{ marginTop: "20px", textAlign: "left", display: "inline-block" }}>
                            <h3>Add New Schedule</h3>
                            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                                <label style={{ flex: "1", textAlign: "right", marginRight: "10px" }}>Timezone (UTC+-): </label>
                                <input
                                    type="number"
                                    name="timezone"
                                    value={newSchedule.timezone}
                                    onChange={handleScheduleInputChange}
                                    style={{ padding: "5px", fontSize: "14px", width: "80px" }}
                                />
                            </div>
                            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                                <label style={{ flex: "1", textAlign: "right", marginRight: "10px" }}>Date Start: </label>
                                <input
                                    type="date"
                                    name="dateStart"
                                    value={newSchedule.dateStart}
                                    onChange={handleScheduleInputChange}
                                    style={{ padding: "5px", fontSize: "14px", width: "150px" }}
                                />
                            </div>
                            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                                <label style={{ flex: "1", textAlign: "right", marginRight: "10px" }}>Time Start (HH:MM): </label>
                                <input
                                    type="time"
                                    name="timeStart"
                                    value={newSchedule.timeStart}
                                    onChange={handleScheduleInputChange}
                                    style={{ padding: "5px", fontSize: "14px", width: "150px" }}
                                />
                            </div>
                            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                                <label style={{ flex: "1", textAlign: "right", marginRight: "10px" }}>Date End: </label>
                                <input
                                    type="date"
                                    name="dateEnd"
                                    value={newSchedule.dateEnd}
                                    onChange={handleScheduleInputChange}
                                    style={{ padding: "5px", fontSize: "14px", width: "150px" }}
                                />
                            </div>
                            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                                <label style={{ flex: "1", textAlign: "right", marginRight: "10px" }}>Time End (HH:MM): </label>
                                <input
                                    type="time"
                                    name="timeEnd"
                                    value={newSchedule.timeEnd}
                                    onChange={handleScheduleInputChange}
                                    style={{ padding: "5px", fontSize: "14px", width: "150px" }}
                                />
                            </div>
                            <div style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}>
                                <label style={{ flex: "1", textAlign: "right", marginRight: "10px" }}>Aroma Scent: </label>
                                <select
                                    name="aromaScent"
                                    value={newSchedule.aromaScent}
                                    onChange={handleScheduleInputChange}
                                    style={{ padding: "5px", fontSize: "14px", width: "150px" }}
                                >
                                    <option value="Metal">Metal</option>
                                    <option value="Wood">Wood</option>
                                    <option value="Fire">Fire</option>
                                    <option value="Earth">Earth</option>
                                    <option value="OFF">OFF</option>
                                </select>
                            </div>
                            <div style={{ marginBottom: "10px", display: "flex", alignItems: "right" }}>
                                <label style={{ flex: "1", textAlign: "right", marginRight: "10px" }}>Aroma Intensity: </label><span>(1-100)</span>
                                <div style={{ display: "flex", alignItems: "right" }}>
                                    <input
                                        type="number"
                                        name="aromaIntensity"
                                        value={newSchedule.aromaIntensity}
                                        onChange={handleScheduleInputChange}
                                        disabled={newSchedule.aromaScent === "OFF"}
                                        style={{
                                            padding: "5px",
                                            fontSize: "14px",
                                            width: "85px",
                                            marginLeft: "10px",
                                            marginRight: "0px",
                                        }}
                                    />

                                </div>
                            </div>
                            <div style={{ textAlign: "center", marginTop: "20px" }}>
                                <button
                                    onClick={handleAddScheduleSubmit}
                                    style={{
                                        padding: "10px 20px",
                                        fontSize: "16px",
                                        cursor: "pointer",
                                        backgroundColor: "#4CAF50",
                                        color: "white",
                                        border: "none",
                                        borderRadius: "5px",
                                    }}
                                >
                                    Submit Schedule
                                </button>
                            </div>
                        </div>
                    )}
                    <style>
                        {`
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    `}
                    </style>
                </div>
            ) : null}
        </div>
    );
}

export default AdminPage;